import {setSrcFromDataSrc} from "./utilities";

const stories = () => {
    const storiesFilterItems = document.querySelectorAll('.stories-filter__item');
    if (storiesFilterItems.length) {
        storiesFilterItems.forEach(item => {
            item.addEventListener('click', (e) => {
                [...storiesFilterItems].find(item => item.classList.contains('active'))?.classList.remove('active');
                e.currentTarget.classList.add('active');
            });
        });
    }
}
export default stories;
